import { API_URL } from "../Config/Api";
import { api } from "../Config/Api";

const SESSION_ID_KEY = "analytics_session_id";

const trackedEvents = new Set<string>();

const getSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_ID_KEY);

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
};

// export const trackEvent = async (
//   eventType: string,
//   payload?: {
//     page?: string;
//     productId?: number;
//     orderId?: number;
//     metadata?: string;
//   }
// ) => {
//   try {
//     await fetch(`${API_URL}/analytics/events`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         eventType,
//         page: payload?.page || window.location.pathname,
//         productId: payload?.productId,
//         orderId: payload?.orderId,
//         sessionId: getSessionId(),
//         deviceType: window.innerWidth < 768 ? "MOBILE" : "DESKTOP",
//         referrer: document.referrer || "direct",
//         metadata: payload?.metadata || null,
//       }),
//     });
//   } catch (error) {
//     console.error("Analytics tracking failed:", error);
//   }
// };


export const trackEvent = async (
  eventType: string,
  payload?: {
    page?: string;
    productId?: number;
    orderId?: number;
    metadata?: string;
  }
) => {
  const page = payload?.page || window.location.pathname;

  const eventKey = `${eventType}_${page}_${payload?.productId || ""}_${payload?.orderId || ""}`;

  if (trackedEvents.has(eventKey)) {
    return;
  }

  trackedEvents.add(eventKey);

  try {
    await api.post("/analytics/events", {
      eventType,
      page,
      productId: payload?.productId,
      orderId: payload?.orderId,
      sessionId: getSessionId(),
      deviceType: window.innerWidth < 768 ? "MOBILE" : "DESKTOP",
      referrer: document.referrer || "direct",
      metadata: payload?.metadata || null,
    });
  } catch (error) {
    trackedEvents.delete(eventKey);
    console.error("Analytics tracking failed:", error);
  }
};